import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import TagManager from 'react-gtm-module';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "context/context-language";
import { ContactProvider } from "context/context-contacto";

// const tagManagerArgs = {
//   gtmId: 'GTM-5B569W3Z', // Reemplaza con tu ID real
// };

// TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <LanguageProvider languageDefault={'es'}>
      <ContactProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </ContactProvider>
    </LanguageProvider>

  </BrowserRouter>
);